<template>
  <div class="rgbSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="rgbSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="rgbSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.RelaySSR2ASettings_text1}}
        </template>
        <template v-slot:body>
          <div class="lxn-w100" ref="widthRef"></div>
          <div v-if="output.type == 'rgb'" class="rgbSettings-wrapper-RGBWWidget">
            <div style="height: 15px;" class="lxn-w100">
            </div>
            <div class="rgbSettings-RGBWWidget-wrapper-d1 lxn-circle lxn-overflow-hidden lxn-margin-auto" :style="shadowStyle">
              <ButtonIcon @click="toggleRGB()" :size="40" :bgColor="rgbBgColor" icon="turnOff" :iconColor="rgbIconColor" :padding="14" :isRound="true" />
            </div>
          </div>
          <div style="width: 100%;margin-top: 20px;">
            <div id="lxn-color-picker"></div>
            <div v-if="output.name == 'Red' || (output.type == 'rgb' && (widget.settings.paletteType == '3' || widget.settings.paletteType == '4'))" class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_red}}
            </div>
            <div id="lxn-color-picker-r"></div>
            <div v-if="output.name == 'Green' || (output.type == 'rgb' && (widget.settings.paletteType == '3' || widget.settings.paletteType == '4'))" class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_green}}
            </div>
            <div id="lxn-color-picker-g"></div>
            <div v-if="output.name == 'Blue' || (output.type == 'rgb' && (widget.settings.paletteType == '3' || widget.settings.paletteType == '4'))" class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_blue}}
            </div>
            <div id="lxn-color-picker-b"></div>
            <div v-if="output.name == 'White' || (output.type == 'rgb' && widget.settings.paletteType == '4')" class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_white}}
            </div>
            <div id="lxn-color-picker-w"></div>
          </div>
        </template>
      </TitleBox>
    </div>
    <div class="rgbSettings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="goBack" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.LoginRegister_back}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE11 from '@/statics/devices/Node11/header.js'
import iro from '@jaames/iro';

export default {
  name: 'rgbSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    ButtonIcon,
  },
  data: function () {
    var widget = this.$store.state.widgets[this.$route.params.index];
    var node = this.$store.getters.getNodeByUUID(widget.nodeUUIDs[0]);

    return {
      node: node,
      widget: widget,
      shadowBlur: 15,
      colorPicker: null,
      colorPicker_r: null,
      colorPicker_g: null,
      colorPicker_b: null,
      colorPicker_w: null,
      colorChangeTimeoutHandle: -1,
      debounceDelay: 100,
      color: {
        hue: 0,
        saturation: 0,
        value: 0,
        white: 0,
      },
      colorLocked: false,
      colorPickerType: widget.settings.paletteType,
    }
  },
  mounted: async function () {
    if(this.output.type == 'rgb'){
      if(this.colorPickerType == 0){
        this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
          width: this.$refs.widthRef.offsetWidth,
          borderWidth: 5,
          layout: [
            { 
              component: iro.ui.Wheel,
            },
            { 
              component: iro.ui.Slider,
            },
          ]
        });
      }else if(this.colorPickerType == 1){
        this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
          width: this.$refs.widthRef.offsetWidth,
          borderWidth: 5,
          layout: [
            { 
              component: iro.ui.Slider,
              options: {
                sliderType: 'hue'
              }
            },
            { 
              component: iro.ui.Box,
            },
          ]
        });
      }else if(this.colorPickerType == 2){
        this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
          width: this.$refs.widthRef.offsetWidth,
          borderWidth: 5,
          layout: [
            { 
              component: iro.ui.Slider,
              options: {
                sliderType: 'kelvin',
                sliderShape: 'circle'
              }
            },
            { 
              component: iro.ui.Slider,
              options: {
                sliderType: 'value'
              }
            },
          ]
        });
      }
      if(this.colorPickerType == 0 || this.colorPickerType == 1 || this.colorPickerType == 2){
        this.colorPicker.color.hsv = this.currentColor;
        this.colorPicker.on('color:change', this.onColorChange);
      }
    }
    if((this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) || this.output.name == "Red"){
      this.colorPicker_r = new iro.ColorPicker("#lxn-color-picker-r", {
        width: this.$refs.widthRef.offsetWidth,
        borderWidth: 5,
        color: "#F00",
        layout: [
          { 
            component: iro.ui.Slider,
            options: {
              sliderType: "value",
              sliderShape: this.output.name == "Red" ? 'circle' : ''
            }
          },
        ]
      });
      this.colorPicker_r.color.hsv = {
        h: 0,
        s: 100,
        v: Math.floor((this.currentColor.r / 255) * 100),
      }
      this.colorPicker_r.on('color:change', this.onColorChange_r);
    }
    if((this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) || this.output.name == "Green"){
      this.colorPicker_g = new iro.ColorPicker("#lxn-color-picker-g", {
        width: this.$refs.widthRef.offsetWidth,
        borderWidth: 5,
        color: "#0F0",
        layout: [
          { 
            component: iro.ui.Slider,
            options: {
              sliderType: "value",
              sliderShape: this.output.name == "Green" ? 'circle' : ''
            }
          },
        ]
      });
      this.colorPicker_g.color.hsv = {
        h: 120,
        s: 100,
        v: Math.floor((this.currentColor.g / 255) * 100),
      }
      this.colorPicker_g.on('color:change', this.onColorChange_g);
    }
    if((this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) || this.output.name == "Blue"){
      this.colorPicker_b = new iro.ColorPicker("#lxn-color-picker-b", {
        width: this.$refs.widthRef.offsetWidth,
        borderWidth: 5,
        color: "#00F",
        layout: [
          { 
            component: iro.ui.Slider,
            options: {
              sliderType: "value",
              sliderShape: this.output.name == "Blue" ? 'circle' : ''
            }
          },
        ]
      });
      this.colorPicker_b.color.hsv = {
        h: 240,
        s: 100,
        v: Math.floor((this.currentColor.b / 255) * 100),
      }
      this.colorPicker_b.on('color:change', this.onColorChange_b);
    }
    if((this.output.type == 'rgb' && this.colorPickerType == 4) || this.output.name == "White"){
      this.colorPicker_w = new iro.ColorPicker("#lxn-color-picker-w", {
        width: this.$refs.widthRef.offsetWidth,
        borderWidth: 5,
        color: "#FFF",
        layout: [
          { 
            component: iro.ui.Slider,
            options: {
              sliderType: "value",
              sliderShape: this.output.name == "White" ? 'circle' : ''
            }
          },
        ]
      });
      this.colorPicker_w.color.hsv = {
        h: 0,
        s: 0,
        v: this.currentColor.w,
      }
      this.colorPicker_w.on('color:change', this.onColorChange_w);
    }
    this.color.hue = Math.floor((this.currentColor.h / 360) * 65535);
    this.color.saturation = Math.floor((this.currentColor.s / 100) * 65535);
    //Math.min is due to a bug in iro.js causing value to be more than 100!
    this.color.value = Math.floor(( Math.min(this.currentColor.v, 100) / 100) * 65535);
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
    if(this.colorPicker){
      this.colorPicker.off('color:change', this.onColorChange);
    }
    if(this.colorPicker_w){
      this.colorPicker_w.off('color:change', this.onColorChange_w);
    }
    if(this.colorPicker_r){
      this.colorPicker_r.off('color:change', this.onColorChange_r);
    }
    if(this.colorPicker_g){
      this.colorPicker_g.off('color:change', this.onColorChange_g);
    }
    if(this.colorPicker_b){
      this.colorPicker_b.off('color:change', this.onColorChange_b);
    }
  },
  watch: {
    currentColor: function (newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
        this.colorLocked = true;
        if(this.colorPicker){
          this.colorPicker.color.hsv = newVal;
        }
        if(this.colorPicker_r){
          this.colorPicker_r.color.hsv = {
            h: 0,
            s: 100,
            v: Math.floor((newVal.r / 255) * 100),
          }
        }
        if(this.colorPicker_g){
          this.colorPicker_g.color.hsv = {
            h: 120,
            s: 100,
            v: Math.floor((newVal.g / 255) * 100),
          }
        }
        if(this.colorPicker_b){
          this.colorPicker_b.color.hsv = {
            h: 240,
            s: 100,
            v: Math.floor((newVal.b / 255) * 100),
          }
        }
        if(this.colorPicker_w){
          this.colorPicker_w.color.hsv = {
            h: 0,
            s: 0,
            v: newVal.w,
          }
        }
        this.colorLocked = false;
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.widget.color];
    },
    output: function () {
      return this.node.outputs[this.widget.settings.outputIndex];
    },
    currentColor: function () {
      var currentHue = this.$store.getters.getParameterValue(this.node.index, NODE11.HUE.PARAMETER_ID);
      var currentSaturation = this.$store.getters.getParameterValue(this.node.index, NODE11.SATURATION.PARAMETER_ID);
      var currentValue = this.$store.getters.getParameterValue(this.node.index, NODE11.BRIGHTNESS.PARAMETER_ID);
      // var currentWhite = this.$store.getters.getParameterValue(this.node.index, NODE9.WHITE.PARAMETER_ID);
      // if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined && currentWhite !== undefined){
      if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined){
        var currentColor = {
          h: Math.floor((currentHue / 65535) * 360),
          s: Math.floor((currentSaturation / 65535) * 100),
          v: Math.floor((currentValue / 65535) * 100),
          // w: Math.floor((currentWhite / 65535) * 100),
        }
        var currentRGB = iro.Color.hsvToRgb(currentColor);
        currentColor.r = currentRGB.r;
        currentColor.g = currentRGB.g;
        currentColor.b = currentRGB.b;
      }else{
        currentColor = {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          w: 0,
        }
      }
      return currentColor;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    shadowStyle: function () {
      if(this.colorPicker){
        var shadowSpread = Math.floor(this.colorPicker.color.hsv.v / 10);
        var shadowColor = this.colorPicker.color.hexString;
      }else if( (this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) && this.colorPicker_r && this.colorPicker_g &&  this.colorPicker_b ){
        var currentRGB = {
          r: Math.floor((this.colorPicker_r.color.hsv.v / 100) * 255),
          g: Math.floor((this.colorPicker_g.color.hsv.v / 100) * 255),
          b: Math.floor((this.colorPicker_b.color.hsv.v / 100) * 255),
        }
        var currentHSV = iro.Color.rgbToHsv(currentRGB);
        shadowSpread = Math.floor(currentHSV.v / 10);
        shadowColor = `rgb(${currentRGB.r},${currentRGB.g},${currentRGB.b})`;
      }else{
        shadowSpread = 10;
        shadowColor = "#FFFFFF";
      }
      return `box-shadow: 0 0 ${this.shadowBlur}px ${shadowSpread}px ${shadowColor};background-color: ${this.rgbBgColor}`;
    },
    rgbBgColor: function () {
      if(this.colorPicker && this.colorPicker.color.hsv.v !== 0){
        if(this.colorPicker.color.hsv.v !== 0){
          return "#FFFFFF";
        }else{
          return "#132f45";
        }
      }else if( (this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) && this.colorPicker_r && this.colorPicker_g &&  this.colorPicker_b ){
        var currentRGB = {
          r: Math.floor((this.colorPicker_r.color.hsv.v / 100) * 255),
          g: Math.floor((this.colorPicker_g.color.hsv.v / 100) * 255),
          b: Math.floor((this.colorPicker_b.color.hsv.v / 100) * 255),
        }
        var currentHSV = iro.Color.rgbToHsv(currentRGB);
        if(currentHSV.v !== 0){
          return "#FFFFFF";
        }else{
          return "#132f45"; 
        }
      }else{
        return "#FFFFFF";
      }
    },
    rgbIconColor: function () {
      if(this.colorPicker && this.colorPicker.color.hsv.v !== 0){
        if(this.colorPicker.color.hsv.v !== 0){
          return "#1d394f";
        }else{
          return "#87b4c7";
        }
      }else if( (this.output.type == 'rgb' && (this.colorPickerType == 3 || this.colorPickerType == 4)) && this.colorPicker_r && this.colorPicker_g &&  this.colorPicker_b ){
        var currentRGB = {
          r: Math.floor((this.colorPicker_r.color.hsv.v / 100) * 255),
          g: Math.floor((this.colorPicker_g.color.hsv.v / 100) * 255),
          b: Math.floor((this.colorPicker_b.color.hsv.v / 100) * 255),
        }
        var currentHSV = iro.Color.rgbToHsv(currentRGB);
        if(currentHSV.v !== 0){
          return "#1d394f";
        }else{
          return "#87b4c7"; 
        }
      }else{
        return "#1d394f";
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    toggleRGB: async function () {
      if(!this.colorLocked){
        this.$store.commit('setAppBusy', true);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: false,
        });
        if(this.color.value == 0){
          this.color.value = 65535;
        }else{
          this.color.value = 0;
        }

        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: this.hub.psk,
          destinationUUID: this.hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        try {
          await this.$store.dispatch('setNodesParameters', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.node.uuid,
            bodyContent: {
              nodeActions: [
                {
                  nodeUUID: this.node.uuid,
                  actions: [
                    {
                      parameterId: NODE11.ANIMATION_MODE.PARAMETER_ID,
                      valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    },
                    {
                      parameterId: NODE11.BRIGHTNESS.PARAMETER_ID,
                      valueOfChange: this.color.value,
                      typeOfAction: CONFIGS.ACTION_TYPE_SET,
                      timeDelay: 0
                    },
                  ]
                },
              ]
            }
          })
          this.currentColor.v = Math.floor((this.color.value / 65535) * 100);
          console.log(this.currentColor.v);
          console.log("DONE");
        }
        catch (response) {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
        }
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        this.$store.commit('setAppBusy', false);
      }
    },
    onColorChange: function (color) {
      if(!this.colorLocked){
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });
          this.color.hue = Math.floor((color.hsv.h / 360) * 65535);
          this.color.saturation = Math.floor((color.hsv.s / 100) * 65535);
          //Math.min is due to a bug in iro.js causing value to be more than 100!
          this.color.value = Math.floor(( Math.min(color.hsv.v, 100) / 100) * 65535);

          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: [
                      {
                        parameterId: NODE11.ANIMATION_MODE.PARAMETER_ID,
                        valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.HUE.PARAMETER_ID,
                        valueOfChange: this.color.hue,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.SATURATION.PARAMETER_ID,
                        valueOfChange: this.color.saturation,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.BRIGHTNESS.PARAMETER_ID,
                        valueOfChange: this.color.value,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                    ]
                  },
                ]
              }
            })
            console.log("DONE");
          }
          catch (response) {
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    },
    onColorChange_r: function () {
      this.onColorChange_single('Red');
    },
    onColorChange_g: function () {
      this.onColorChange_single('Green');
    },
    onColorChange_b: function () {
      this.onColorChange_single('Blue');
    },
    onColorChange_w: function () {
      this.onColorChange_single('White');
    },
    onColorChange_single: function (targetColor) {
      if(!this.colorLocked){
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });

          var currentRGB = {
            r: this.currentColor.r,
            g: this.currentColor.g,
            b: this.currentColor.b,
          }
          if(targetColor == "Red"){
            currentRGB.r = Math.min(Math.floor((this.colorPicker_r.color.hsv.v / 100) * 255), 255);
          }else if(targetColor == "Green"){
            currentRGB.g = Math.min(Math.floor((this.colorPicker_g.color.hsv.v / 100) * 255), 255);
          }else if(targetColor == "Blue"){
            currentRGB.b = Math.min(Math.floor((this.colorPicker_b.color.hsv.v / 100) * 255), 255);
          }else{
            this.color.white = Math.floor((Math.min(this.colorPicker_w.color.hsv.v, 100) / 100) * 65535);
          }
          var currentHSV = iro.Color.rgbToHsv(currentRGB);
          this.color.hue = Math.floor((currentHSV.h / 360) * 65535);
          this.color.saturation = Math.floor((currentHSV.s / 100) * 65535);
          this.color.value = Math.floor(( Math.min(currentHSV.v, 100) / 100) * 65535);

          var actions = [];
          actions.push({
            parameterId: NODE11.ANIMATION_MODE.PARAMETER_ID,
            valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
            typeOfAction: CONFIGS.ACTION_TYPE_SET,
            timeDelay: 0
          });
          if(targetColor == "White"){
            actions.push(
              {
                parameterId: NODE11.WHITE.PARAMETER_ID,
                valueOfChange: this.color.white,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
                timeDelay: 0
              }
            );
          }else{
            actions.push(
              {
                parameterId: NODE11.HUE.PARAMETER_ID,
                valueOfChange: this.color.hue,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
                timeDelay: 0
              }
            );
            actions.push(
              {
                parameterId: NODE11.SATURATION.PARAMETER_ID,
                valueOfChange: this.color.saturation,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
                timeDelay: 0
              }
            );
            actions.push(
              {
                parameterId: NODE11.BRIGHTNESS.PARAMETER_ID,
                valueOfChange: this.color.value,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
                timeDelay: 0
              }
            );
          }
          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: actions
                  },
                ]
              }
            })
            console.log("DONE");
          }
          catch (response) {
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    }
  }
}
</script>

<style>
  .rgbSettings-topCurve-wrapper {
    height: 200px;
  }
  .rgbSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .rgbSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .rgbSettings-wrapper-fieldTitles {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
    color: #52626C;
  }
  .rgbSettings-wrapper-RGBWWidget {
    height: 70px;
  }
  .rgbSettings-RGBWWidget-wrapper-d1 {
    width: 40px;
    height: 40px;
    transition: all 300ms linear;
  }
</style>
